///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import messages from "./messages";

export const capacityMatchLaneSummaryColumns = [
  {
    fieldName: "truckloadLaneId",
    checkbox: true,
    maxWidth: 50,
    isFilter: false,
    sortEnabled: false,
    resize: false,
    isDraggable: false
  },
  {
    fieldName: "shipperLaneId",
    label: messages.laneId.defaultMessage,
    minWidth: 105,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "originCity",
    label: messages.origCity.defaultMessage,
    minWidth: 110,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "originState",
    label: messages.origSt.defaultMessage,
    minWidth: 100,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "originPostalCode",
    label: messages.origPostal.defaultMessage,
    minWidth: 125,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "originCountry",
    label: messages.origCountry.defaultMessage,
    minWidth: 135,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "destinationCity",
    label: messages.destCity.defaultMessage,
    minWidth: 115,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "destinationState",
    label: messages.destSt.defaultMessage,
    minWidth: 100,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "destinationPostalCode",
    label: messages.destPostal.defaultMessage,
    minWidth: 125,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "destinationCountry",
    label: messages.destCountry.defaultMessage,
    minWidth: 135,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "equipmentType",
    label: messages.eq.defaultMessage,
    minWidth: 85,
    isFilter: true,
    sortEnabled: true,
    left: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "volume",
    label: messages.volume.defaultMessage,
    minWidth: 110,
    isFilter: true,
    sortEnabled: true,
    right: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "groups",
    label: messages.group.defaultMessage,
    minWidth: 150,
    isFilter: true,
    sortEnabled: true,
    left: true,
    checkCapacityStatusForSorting: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "procurementRepNames",
    label: messages.procurementReps.defaultMessage,
    minWidth: 200,
    isFilter: true,
    sortEnabled: true,
    left: true,
    checkCapacityStatusForSorting: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "carrierNames",
    label: messages.carriers.defaultMessage,
    minWidth: 200,
    isFilter: true,
    sortEnabled: true,
    left: true,
    checkCapacityStatusForSorting: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "repNames",
    label: messages.carrierReps.defaultMessage,
    minWidth: 200,
    isFilter: true,
    sortEnabled: true,
    left: true,
    checkCapacityStatusForSorting: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "incumbentMatchesCount",
    label: messages.incumbent.defaultMessage,
    minWidth: 100,
    isFilter: false,
    sortEnabled: true,
    left: true,
    checkCapacityStatusForSorting: true,
    resize: true,
    isDraggable: true
  },
  {
    fieldName: "matches",
    label: messages.matches.defaultMessage,
    minWidth: 350,
    isFilter: false,
    sortEnabled: false,
    resize: false,
    hideLabel: true,
    isDraggable: false
  }
];

export default capacityMatchLaneSummaryColumns;
